import { observer } from "mobx-react-lite"

import { useScaleApplication } from "@/domains/application/use-scale-application"
import { SwapAggregatorsSection } from "@/domains/swap/components/composables/swap-settings-sections/swap-aggregators-section"
import type { SwapAggregator } from "@/domains/swap/components/composables/swap-settings-sections/swap-aggregators-section"
import { SwapAggregatorStore } from "@/domains/swap-aggregators/swap-aggregator-store"
import type { SwapFallbackMode } from "@/domains/swap-aggregators/types"

/**
 * Business logic wrapper for SwapAggregatorsSection.
 * Handles MobX observer logic and scaleApp interactions.
 */
export const SwapAggregatorsSectionWrapper = observer(() => {
  const scaleApp = useScaleApplication()
  const aggregators = scaleApp?.Settings.SwapAggregators.getProductionReadyAggregators() ?? []

  // Map MobX stores to UI-only component props
  const aggregatorsForUI: Array<SwapAggregator> = aggregators.map((agg: SwapAggregatorStore) => ({
    id: agg.id,
    name: agg.name,
    description: agg.description,
    icon: agg.icon,
    enabled: agg.id === scaleApp.Settings.SwapAggregators.activeFallbackAggregatorId,
  }))

  const handleFallbackAggregatorSelect = (aggregatorId: string) => {
    scaleApp.Settings.SwapAggregators.setActiveFallbackAggregator(aggregatorId)
  }

  const handleFallbackModeChange = (mode: SwapFallbackMode) => {
    scaleApp.Settings.SwapAggregators.setFallbackMode(mode)
  }

  return (
    <SwapAggregatorsSection
      aggregators={aggregatorsForUI}
      fallbackMode={scaleApp.Settings.SwapAggregators.fallbackMode}
      onFallbackAggregatorSelect={handleFallbackAggregatorSelect}
      onFallbackModeChange={handleFallbackModeChange}
    />
  )
})

